"use client"
import styled from "@emotion/styled"
import { SxProps, Typography } from "@mui/material"
import { replaceRichTextLinks } from "utils"

type PortTitleProps = {
  normalText?: string
  highlightedText?: string
  highlightedFirst?: boolean
  subtitle?: string
  centered?: boolean
  overwrittenColor?: string
  richSubtitle?: boolean
  titleSx?: SxProps
  subtitleSx?: SxProps
}

const StyledTitle = styled(Typography)<{ $isCentered?: boolean; $overwrittenColor?: string }>`
  text-transform: capitalize;
  font-weight: 400;
  text-transform: capitalize;
  color: ${({ theme, $overwrittenColor }) =>
    $overwrittenColor || theme.colors.port.defaultTextColor};
  text-align: ${(props) => (props.$isCentered ? "center" : "left")};
  ${(props) => props.theme.breakpoints.up("md")} {
    letter-spacing: -1.6px;
  }
`

const StyledSubtitle = styled(Typography)<{
  $isCentered?: boolean
  $overwrittenColor?: string
  component?: "div" | "p"
}>`
  margin: 0;
  padding: 0;
  font-weight: 400;
  letter-spacing: 0.6px;
  text-transform: capitalize;
  margin-top: 16px;
  text-align: ${(props) => (props.$isCentered ? "center" : "left")};
  color: ${({ $overwrittenColor }) => $overwrittenColor || "inherit"};
  ${(props) => props.theme.breakpoints.up("md")} {
    letter-spacing: unset;
  }
`

const PortTitle = ({
  normalText,
  highlightedText,
  highlightedFirst,
  centered,
  overwrittenColor,
  subtitle,
  richSubtitle,
  titleSx,
  subtitleSx,
}: PortTitleProps) => {
  const as: "div" | "p" = richSubtitle ? "div" : "p"

  const normalSpan = normalText ? <span>{normalText}</span> : null
  const highlightedSpan = highlightedText ? (
    <span style={{ color: overwrittenColor || "#0000FA" }}>{highlightedText}</span>
  ) : null

  const firstSpan = highlightedFirst ? highlightedSpan : normalSpan
  const secondSpan = highlightedFirst ? normalSpan : highlightedSpan

  return (
    <>
      {(normalText || highlightedText) && (
        <StyledTitle
          dir="auto"
          $isCentered={centered}
          $overwrittenColor={overwrittenColor}
          sx={{
            fontSize: {
              xs: "50px",
              md: "80px",
            },
            lineHeight: {
              xs: "120%",
            },
            ...titleSx,
          }}
        >
          {firstSpan}
          {firstSpan && secondSpan && " "}
          {secondSpan}
        </StyledTitle>
      )}
      {subtitle && richSubtitle ? (
        <StyledSubtitle
          component={as}
          $isCentered={centered}
          $overwrittenColor={overwrittenColor}
          dangerouslySetInnerHTML={{ __html: replaceRichTextLinks(subtitle) }}
          sx={subtitleSx}
        />
      ) : (
        <StyledSubtitle
          component={as}
          $isCentered={centered}
          $overwrittenColor={overwrittenColor}
          sx={{
            fontSize: {
              xs: "20px",
              md: "24px",
            },
            lineHeight: {
              xs: "150%",
            },
            ...subtitleSx,
          }}
        >
          {subtitle}
        </StyledSubtitle>
      )}
    </>
  )
}
export default PortTitle
